import isArray from 'lodash/isArray';
import { ParamsType } from '../types';

export const getUtmSource = (params: ParamsType) => {
    let utmSource = params.utm_source;

    if (isArray(utmSource)) {
        [utmSource] = utmSource;
    }

    return utmSource && utmSource.toLowerCase();
};
